import { render } from "./UploadMediaView.vue?vue&type=template&id=6652d9b9&scoped=true"
import script from "./UploadMediaView.vue?vue&type=script&lang=js"
export * from "./UploadMediaView.vue?vue&type=script&lang=js"

import "./UploadMediaView.vue?vue&type=style&index=0&id=6652d9b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6652d9b9"]])

export default __exports__